/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "slide": {
    "caption_colors_default": "text-al-petroleum-600"
  },
  "swiper": {
    "arrow_colors_default": "text-al-petroleum-600",
    "navigation_item_colors_default": "bg-primary-600 data-[active=true]:bg-primary-200",
    "title_colors_default": "text-al-petroleum-600",
    "title_size_default": "text-al-headline-sm md:text-al-headline-md pb-3 md:pb-5",
    "title_variant_default": "text-center",
    "navigation_variant_default": "hidden",
    "content_size_default": "w-full"
  },
  "colors_default": "bg-al-korall-100 wings-al-korall-100",
  "size_default": "py-3 md:py-6 w-screen -ml-[calc(50vw-50%)] md:w-full md:ml-0",
  "variant_default": "relative wings"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "BlogSlider");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;